import React from "react"
import LoaderImg from "../../images/loader.png"
function Loader(){
    return (
        <div className="loader">
            <img className="loader__img" src={LoaderImg} />
        </div>
    )
}
export default Loader